export default {
  setConsumerEmpBoxesFlagAction({ commit }, payload) {
    commit("ConsumerEmpBoxesFlagMut", payload);
  },
  setInsuranceBoxFlagAction({ commit }, payload) {
    commit("InsuranceBoxFlagMut", payload);
  },
  setpersonalizedFlagAction({ commit }, payload) {
    commit("personalizedFlagMut", payload);
  },
};
